import { constants } from "@newsela/angelou";

const { ui } = constants.colors;

export const buttonCss = {
  root: {
    padding: 0,
    marginLeft: 5,
    color: ui.white[50],
    textDecoration: "underline",
  },
};
